import Vue from 'vue'
import Router from 'vue-router'
//import Login from '@/page/login'
import Index from '@/page/knowledge'
import Knowledgedw from '@/page/knowledgedw'
import EvenEtMap from '@/page/eventMap'

Vue.use(Router)

export default new Router({
    // pageType判断页面属于哪个导航分类
    // keepAlive 不同页面的颜色 首页1
    mode: 'history',  //去掉url中的#
    routes: [
        /**首页**/
        {
            path: '/',
            name: 'index',
            component: Index,
            meta:{
                title:'知识图谱',
                requireAuth: true,//登录状态
                topShow:true,
                footShow:false,
                keepAlive:5,
                pageType:7
            }
        },
        {
            path: '/eventMap',
            name: 'eventMap',
            component: EvenEtMap,
            meta:{
                title:'知识图谱',
                requireAuth: true,//登录状态
                topShow:true,
                footShow:false,
                keepAlive:1,
                pageType:7
            }
        },{
            path: '/Knowledgedw',
            name: 'Knowledgedw',
            component: Knowledgedw,
            meta:{
                title:'知识图谱',
                requireAuth: true,//登录状态
                topShow:false,
                footShow:false,
                keepAlive:5,
                pageType:7
            }
        },
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js